import { useTranslation } from "react-i18next";
import type { VenueHours } from "./types";

const DAY_KEYS = [
  "venues.days.sunday",
  "venues.days.monday",
  "venues.days.tuesday",
  "venues.days.wednesday",
  "venues.days.thursday",
  "venues.days.friday",
  "venues.days.saturday",
] as const;

interface VenueHoursTableProps {
  readonly hours: readonly VenueHours[];
}

export function VenueHoursTable({ hours }: VenueHoursTableProps) {
  const { t } = useTranslation();

  if (hours.length === 0) return null;

  const valid = hours.filter((h) => h.dayOfWeek >= 0 && h.dayOfWeek <= 6);
  const sorted = [...valid].sort((a, b) => a.dayOfWeek - b.dayOfWeek);

  return (
    <div data-testid="venue-hours-table" className="space-y-1">
      {sorted.map((h) => (
        <div
          key={`${h.dayOfWeek}-${h.openTime}-${h.closeTime}`}
          className="flex items-center justify-between font-sans text-sm font-normal"
        >
          <span className="text-muted-foreground">{t(DAY_KEYS[h.dayOfWeek])}</span>
          <span className="text-foreground">
            {h.isClosed ? t("venues.detail.closed") : `${h.openTime} – ${h.closeTime}`}
          </span>
        </div>
      ))}
    </div>
  );
}
